var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgTomtalker = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 535,
    height: 494,
    viewBox: "0 0 535 494",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11158_31070)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.166 435.533H214.125V267.527L228.166 260.993V435.533Z",
    fill: "#F1B9FF",
    stroke: "#040222",
    strokeWidth: 1.86301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.109 429.971V239.901L187.471 264.427V454.497L200.721 448.328V273.758L228.165 260.993V435.533L240.109 429.971Z",
    fill: "#B7C2FF",
    stroke: "#040222",
    strokeWidth: 1.86301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.753 264.427V454.497H465.311V280.14H187.227V454.497H171.241V264.427H481.753Z",
    fill: "#F1B9FF",
    stroke: "#040222",
    strokeWidth: 1.86301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.392 429.971V239.901L481.754 264.427V454.497L495.005 448.328V273.758L522.448 260.993V435.533L534.392 429.971Z",
    fill: "#B7C2FF",
    stroke: "#040222",
    strokeWidth: 1.86301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.447 435.533H508.376V267.527L522.447 260.993V435.533Z",
    fill: "#F1B9FF",
    stroke: "#040222",
    strokeWidth: 1.86301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.757 264.427H171.245L223.853 239.901H534.395L481.757 264.427Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 1.86301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.467 167.478H356.42V227.988H372.467V167.478Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 1.86301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.523 167.478H372.466V227.988H381.523V167.478Z",
    fill: "#B7C2FF",
    stroke: "#040222",
    strokeWidth: 1.86301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.284 167.478H356.42V182.826H372.284V167.478Z",
    fill: "#040222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.454 64.6628H283.783V172.523H451.454V64.6628Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 1.86301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.578 73.385H293.631V163.77H441.578V73.385Z",
    fill: "#5D21D2",
    stroke: "#040222",
    strokeWidth: 1.86301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-12-inside-1_11158_31070",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362.056 140.56C357.373 137.79 347.589 126.361 347.589 113L347.717 103.112C347.725 102.475 348.109 101.904 348.695 101.657L365.03 94.758C365.827 94.4215 366.726 94.4215 367.523 94.758L383.858 101.657C384.444 101.904 384.828 102.475 384.836 103.112L384.964 113C384.964 126.361 375.169 137.48 370.497 140.56C369.291 141.355 367.647 142.202 366.299 142.225C364.954 142.248 363.4 141.355 362.056 140.56Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M362.056 140.56C357.373 137.79 347.589 126.361 347.589 113L347.717 103.112C347.725 102.475 348.109 101.904 348.695 101.657L365.03 94.758C365.827 94.4215 366.726 94.4215 367.523 94.758L383.858 101.657C384.444 101.904 384.828 102.475 384.836 103.112L384.964 113C384.964 126.361 375.169 137.48 370.497 140.56C369.291 141.355 367.647 142.202 366.299 142.225C364.954 142.248 363.4 141.355 362.056 140.56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.589 113L345.726 112.976C345.726 112.984 345.726 112.992 345.726 113H347.589ZM362.056 140.56L361.107 142.164H361.107L362.056 140.56ZM370.497 140.56L371.523 142.115L371.523 142.115L370.497 140.56ZM384.964 113H386.827C386.827 112.992 386.827 112.984 386.827 112.976L384.964 113ZM365.03 94.758L365.755 96.4742L365.755 96.4742L365.03 94.758ZM348.695 101.657L347.97 99.9405H347.97L348.695 101.657ZM383.858 101.657L383.133 103.373V103.373L383.858 101.657ZM367.523 94.758L368.248 93.0418V93.0418L367.523 94.758ZM347.717 103.112L345.854 103.088L347.717 103.112ZM384.836 103.112L382.973 103.136V103.136L384.836 103.112ZM366.299 142.225L366.331 144.088H366.332L366.299 142.225ZM345.726 113C345.726 120.127 348.33 126.664 351.484 131.736C354.615 136.77 358.427 140.578 361.107 142.164L363.004 138.957C361.002 137.772 357.58 134.481 354.648 129.768C351.74 125.092 349.452 119.234 349.452 113H345.726ZM371.523 142.115C374.125 140.399 377.918 136.636 381.061 131.625C384.218 126.593 386.827 120.131 386.827 113H383.101C383.101 119.229 380.813 125.008 377.904 129.646C374.982 134.305 371.54 137.641 369.472 139.005L371.523 142.115ZM364.305 93.0418L347.97 99.9405L349.42 103.373L365.755 96.4742L364.305 93.0418ZM384.583 99.9405L368.248 93.0418L366.798 96.4742L383.133 103.373L384.583 99.9405ZM345.854 103.088L345.726 112.976L349.452 113.024L349.58 103.136L345.854 103.088ZM382.973 103.136L383.101 113.024L386.827 112.976L386.699 103.088L382.973 103.136ZM361.107 142.164C361.772 142.557 362.586 143.034 363.426 143.404C364.25 143.768 365.265 144.106 366.331 144.088L366.267 140.362C365.989 140.367 365.555 140.271 364.929 139.995C364.32 139.726 363.684 139.359 363.004 138.957L361.107 142.164ZM366.332 144.088C367.348 144.07 368.351 143.753 369.187 143.394C370.045 143.025 370.856 142.555 371.523 142.115L369.472 139.005C368.932 139.361 368.318 139.712 367.716 139.971C367.092 140.239 366.599 140.357 366.267 140.362L366.332 144.088ZM347.97 99.9405C346.703 100.476 345.872 101.711 345.854 103.088L349.58 103.136C349.578 103.239 349.516 103.333 349.42 103.373L347.97 99.9405ZM365.755 96.4742C366.088 96.3334 366.465 96.3334 366.798 96.4742L368.248 93.0418C366.987 92.5095 365.566 92.5095 364.305 93.0418L365.755 96.4742ZM383.133 103.373C383.037 103.333 382.975 103.239 382.973 103.136L386.699 103.088C386.681 101.711 385.85 100.476 384.583 99.9405L383.133 103.373Z",
    fill: "#040222",
    mask: "url(#path-12-inside-1_11158_31070)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.332 114.276C371.332 114.719 371.69 115.077 372.133 115.077H372.658C373.137 115.077 373.433 115.374 373.433 115.852V123.207C373.433 123.685 373.137 123.982 372.658 123.982H361.101C360.623 123.982 360.326 123.685 360.326 123.207V115.852C360.326 115.374 360.623 115.077 361.101 115.077H361.626C362.068 115.077 362.427 114.719 362.427 114.276V111.124C362.427 108.675 364.43 106.672 366.879 106.672C369.329 106.672 371.332 108.675 371.332 111.124V114.276ZM370.032 115.077C370.474 115.077 370.833 114.719 370.833 114.276V111.124C370.833 108.951 369.053 107.171 366.88 107.171C364.707 107.171 362.927 108.951 362.927 111.124V114.276C362.927 114.719 363.286 115.077 363.728 115.077H370.032Z",
    fill: "#4B1BAF",
    stroke: "#040222",
    strokeWidth: 1.6018,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.454 172.492L460.572 168.237V60.4075L451.454 64.6623V172.492Z",
    fill: "#B7C2FF",
    stroke: "#040222",
    strokeWidth: 1.86301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.985 32.2651C344.475 31.3837 347.423 33.0249 348.821 36.5807C350.219 40.1365 349.459 43.6923 349.337 44.3306C349.216 44.9688 344.687 42.5375 343.38 38.7081C342.074 34.9395 341.496 33.1768 342.985 32.2651Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 1.86301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.327 29.1043C369.154 28.922 369.032 33.5719 369.032 35.4562C369.032 37.3405 367.421 41.96 366.327 42.0816C365.203 42.2032 363.622 36.7326 363.653 33.815C363.683 30.8974 364.382 29.2259 366.327 29.1043Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 1.86301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.079 45.1208C383.802 45.2727 383.681 39.7718 385.079 37.2189C386.477 34.666 388.908 31.1406 390.428 32.0219C391.947 32.9033 391.431 37.3709 390.428 39.1336C389.394 40.9267 387.115 44.8776 385.079 45.1208Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 1.86301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.901 60.4075H460.572L451.454 64.6623H283.783L292.901 60.4075Z",
    fill: "#F1B9FF",
    stroke: "#040222",
    strokeWidth: 1.86301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.717 257.528H277.31L309.221 242.636H417.658L385.717 257.528Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 1.86301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.22 242.637V227.988L277.309 250.69V257.529L309.22 242.637Z",
    fill: "#B7C2FF",
    stroke: "#040222",
    strokeWidth: 1.86301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.22 227.988H417.657L385.716 250.69H277.309L309.22 227.988Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 1.86301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.773 232.79H399.696L381.188 246.01H293.265L311.773 232.79Z",
    stroke: "#040222",
    strokeWidth: 1.86301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.907 246.01L324.416 232.79",
    stroke: "#040222",
    strokeWidth: 1.86301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.459 246.01L336.968 232.79",
    stroke: "#040222",
    strokeWidth: 1.86301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.011 246.01L349.519 232.79",
    stroke: "#040222",
    strokeWidth: 1.86301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.562 246.01L362.071 232.79",
    stroke: "#040222",
    strokeWidth: 1.86301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.114 246.01L374.592 232.79",
    stroke: "#040222",
    strokeWidth: 1.86301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.636 246.01L387.144 232.79",
    stroke: "#040222",
    strokeWidth: 1.86301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.625 239.385H390.457",
    stroke: "#040222",
    strokeWidth: 1.86301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.747 250.69H277.31V257.528H385.747V250.69Z",
    fill: "#F1B9FF",
    stroke: "#040222",
    strokeWidth: 1.86301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.657 242.637V227.988L385.716 250.69V257.529L417.657 242.637Z",
    fill: "#B7C2FF",
    stroke: "#040222",
    strokeWidth: 1.86301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.416 362.806H85.8701V474.252H96.416V362.806Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 1.86301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.255 366.21C137.141 366.21 150.878 364.538 154.798 353.749C158.719 342.96 149.844 335.423 128.874 334.693C107.873 333.964 71.1603 334.693 55.8429 334.693C40.5255 334.693 29.7061 340.711 29.7061 350.072C29.7061 359.402 34.6295 366.21 54.5057 366.21C74.3818 366.21 111.338 366.21 124.255 366.21Z",
    fill: "#040222",
    stroke: "#040222",
    strokeWidth: 1.86301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4475 484.889C55.4475 488.293 51.1015 491.666 46.877 491.666C42.6526 491.666 39.8262 489.204 39.8262 485.8C39.8262 482.397 44.4761 479.327 48.7005 479.327C52.925 479.297 55.4475 481.454 55.4475 484.889Z",
    fill: "#040222",
    stroke: "#040222",
    strokeWidth: 1.86301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.489 485.193C142.489 488.596 138.142 491.666 133.918 491.666C129.694 491.666 126.867 488.596 126.867 485.193C126.867 481.789 131.213 479.327 135.438 479.327C139.692 479.297 142.489 481.758 142.489 485.193Z",
    fill: "#040222",
    stroke: "#040222",
    strokeWidth: 1.86301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6816 479.297H140.269C140.269 474.252 139.479 469.207 132.55 469.207C124.223 469.207 56.4491 469.207 50.7962 469.207C43.5934 469.207 42.6816 474.191 42.6816 479.297Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 1.86301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3843 487.715C43.4421 486.591 44.5362 484.585 45.8431 484.038C47.1499 483.491 50.2195 481.819 51.04 483.339C51.8606 484.858 49.9763 487.077 48.1224 487.989C46.2989 488.931 45.3264 488.84 44.3843 487.715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.456 487.715C130.513 486.591 131.608 484.585 132.914 484.038C134.221 483.491 137.291 481.819 138.111 483.339C138.932 484.858 137.048 487.077 135.194 487.989C133.34 488.931 132.398 488.84 131.456 487.715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.966 426.931L177.653 448.297L193.731 463.158L210.476 450.211L213.607 426.931L195.645 421.826L180.966 426.931Z",
    fill: "#FAE900",
    stroke: "#040222",
    strokeWidth: 1.86301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.653 448.297C177.653 448.297 173.702 472.671 173.459 474.586C173.216 476.5 173.338 477.382 175.465 477.625C177.592 477.868 187.409 478.719 198.684 478.111C209.96 477.503 233.847 476.044 234.455 476.044C235.063 476.044 235.185 470.817 235.063 468.173C234.942 465.498 235.185 461.639 228.772 460.666C222.359 459.694 214.245 460.636 210.75 457.08C207.255 453.524 206.343 451.822 206.343 451.822C206.343 451.822 197.651 455.226 191.117 455.226C184.583 455.226 181.057 446.96 177.653 448.297Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 1.86301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.769 472.488C175.769 472.488 183.61 473.4 189.475 473.278C194.703 473.187 201.115 472.549 209.473 472.063C217.831 471.576 235.093 471.455 235.093 471.455",
    stroke: "#040222",
    strokeWidth: 1.86301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.776 459.937C219.776 459.937 214.579 466.228 213.242 465.62C211.905 465.012 215.947 459.45 215.947 459.45C215.947 459.45 210.568 466.44 208.653 465.681C206.708 464.921 213.303 458.691 213.303 458.691C213.303 458.691 206.982 464.495 205.887 463.492C204.793 462.49 210.781 457.08 210.781 457.08",
    stroke: "#040222",
    strokeWidth: 0.931506,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.753 431.43L198.197 452.886L213.606 468.447L232.358 455.865L234.789 432.828L220.353 420.337L201.753 431.43Z",
    fill: "#FAE900",
    stroke: "#040222",
    strokeWidth: 1.86301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.589 438.419L208.67 442.993",
    stroke: "#040222",
    strokeWidth: 0.925128,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.994 432.485L186.075 437.059",
    stroke: "#040222",
    strokeWidth: 0.925128,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.865 448.828L213.292 452.909",
    stroke: "#040222",
    strokeWidth: 0.925128,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.27 442.894L190.697 446.975",
    stroke: "#040222",
    strokeWidth: 0.925128,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.934 451.302L223.856 446.76",
    stroke: "#040222",
    strokeWidth: 0.925128,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.065 428.573C215.065 428.573 213.849 440.912 233.421 445.531L234.758 432.797L228.559 420.337L215.065 428.573Z",
    fill: "#040222",
    stroke: "#040222",
    strokeWidth: 1.86301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.198 451.67C198.198 451.67 194.004 479.083 193.731 481.241C193.457 483.399 193.609 484.341 195.949 484.615C198.29 484.888 209.261 485.83 221.813 485.162C234.365 484.493 260.988 482.852 261.656 482.852C262.325 482.852 262.477 477.047 262.325 474.069C262.203 471.09 262.446 466.775 255.304 465.681C248.132 464.587 240.139 465.65 236.249 461.669C232.328 457.688 232.328 455.803 232.328 455.803C232.328 455.803 222.329 460.94 215.035 460.94C207.772 461 201.967 450.211 198.198 451.67Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 1.86301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.283 477.23C196.283 477.23 205.735 477.898 211.54 478.445C217.345 478.992 224.517 478.992 233.817 478.445C243.117 477.898 262.355 477.777 262.355 477.777",
    stroke: "#040222",
    strokeWidth: 1.86301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.306 464.891C245.306 464.891 240.109 471.942 238.619 471.273C237.13 470.604 241.659 464.374 241.659 464.374C241.659 464.374 235.033 472.185 232.875 471.334C230.718 470.483 237.92 463.037 237.92 463.037C237.92 463.037 230.961 470.027 229.745 468.902C228.529 467.778 235.185 460.666 235.185 460.666",
    stroke: "#040222",
    strokeWidth: 0.931506,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.966 426.931L196.831 335.969H114.378L129.088 286.978C129.088 286.978 196.375 286.978 206.647 286.978C216.919 286.978 228.559 287.434 227.161 306.337C225.763 325.241 213.607 426.931 213.607 426.931C213.607 426.931 204.824 429.971 191.816 429.971C182.03 429.971 180.966 426.931 180.966 426.931Z",
    fill: "#B7C2FF",
    stroke: "#040222",
    strokeWidth: 1.86301,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8118 255.219C65.8118 255.219 57.9403 295.609 56.0864 315.029C55.2051 324.208 52.8649 338.857 68.4559 341.713C82.2537 344.236 91.3712 342.959 132.613 342.504C173.854 342.048 215.491 341.136 215.491 341.136L201.754 431.43C201.754 431.43 210.689 432.797 223.058 432.797C235.428 432.797 242.995 431.642 242.995 431.642C242.995 431.642 256.064 346.606 259.042 330.134C262.02 313.631 262.476 292.327 228.559 292.327C194.642 292.327 151.425 292.327 151.425 292.327L155.467 256.769L109.941 250.599L65.8118 255.219Z",
    fill: "#B7C2FF",
    stroke: "#040222",
    strokeWidth: 1.86301,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3106 306.55C70.3106 306.55 67.788 324.876 67.788 329.708C67.788 334.541 66.6332 343.081 79.9143 343.081",
    stroke: "#040222",
    strokeWidth: 1.86301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.609 84.3019C133.959 101.341 122.741 109.053 120.336 112.08L125.04 117.728L131.63 125.259L144.941 129.025L157.991 128.084L165.522 122.435C165.323 121.406 164.947 117.929 164.602 107.782C169.661 107.445 173.916 97.9761 175.81 91.2052C177.326 85.7886 180.092 71.3768 181.286 64.8481C182.514 65.6783 185.349 65.9846 186.864 60.568C188.38 55.1513 185.472 53.3644 183.829 53.1481C184.002 51.8337 184.779 47.4565 186.502 40.4625C188.868 40.774 194.579 37.5143 197.139 35.8455C200.226 35.2491 202.535 40.5674 215.013 37.1958C226.574 34.7062 229.105 24.6762 228.925 19.9724C230.95 16.5162 232.098 12.108 229.751 9.04925C225.471 3.47131 218.44 3.54863 213.252 4.87132C208.063 6.19401 204.197 12.7053 200.514 10.2145C193.042 6.02169 187.283 9.14129 185.337 11.2252C182.976 13.923 179.37 18.4627 175.556 16.9577C168.786 15.0634 164.453 17.5017 159.861 21.9116C155.269 26.3215 150.235 41.705 149.456 47.6199C147.879 47.4122 146.741 47.931 146.369 48.2163C141.803 52.429 143.515 57.2009 144.941 59.0602C144.768 60.3746 143.259 67.2631 138.609 84.3019Z",
    fill: "#FAE900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.944 59.0598L141.492 77.6605C142.236 77.0898 145.784 74.0131 149.561 69.6965C147.667 76.4674 143.358 96.2602 148.236 102.617C153.372 109.311 165.072 111.854 171.039 104.617C175.813 98.8269 179.602 77.6633 180.9 67.8052L152.311 64.0415C152.943 61.7846 154.559 56.1137 156.489 47.5424C158.42 38.9711 160.131 37.6585 160.745 38.0737C163.616 39.1202 170.447 40.5545 174.805 37.919C180.254 34.6247 177.763 38.3084 182.562 39.9431C187.361 41.5778 188.607 39.736 198.128 35.975C205.885 37.9991 211.799 38.7778 218.104 36.5991C224.408 34.4204 228.144 28.8947 229.182 21.0082C234.553 10.6835 231.129 6.22143 221.401 3.93779C211.672 1.65415 208.533 10.2668 204.46 10.7335C200.387 11.2002 202.618 9.48812 194.731 8.44985C186.845 7.41158 182.719 15.8945 180.618 16.6207C178.517 17.3469 174.703 15.842 168.529 17.0349C162.354 18.2278 158.875 24.962 157.113 27.5667C153.377 33.0919 151.137 42.4916 149.329 48.6053L151.301 48.8651L150.133 57.7373C149.717 60.8919 145.887 59.5182 144.944 59.0598Z",
    fill: "#ED7976"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.831 53.1482C184.004 51.8339 184.651 48.4424 186.375 41.4485C188.74 41.7599 194.581 37.5145 197.141 35.8457C200.228 35.2492 203.292 39.865 215.771 36.4933C227.331 34.0037 230.003 23.2291 229.823 18.5253C231.848 15.0691 231.134 10.0554 228.787 6.9966C224.507 1.41866 218.118 2.94128 213.442 4.13286C208.253 5.45514 206.255 13.171 202.571 10.6802C195.1 6.48736 187.7 8.52748 185.339 11.2253C182.978 13.9232 179.372 18.4628 175.558 16.9579C168.787 15.0636 164.455 17.5019 159.863 21.9117C155.271 26.3216 150.237 41.7052 149.458 47.62C147.881 47.4123 146.743 47.9311 146.371 48.2165C141.805 52.4292 143.516 57.201 144.943 59.0603C144.77 60.3747 143.261 67.2633 138.611 84.302C133.961 101.341 123.098 110.102 119.332 112.927L124.099 116.787C124.099 116.787 133.646 129.026 144.943 129.026C159.874 129.026 165.523 122.435 165.523 122.435C165.324 121.406 165.134 119.244 164.474 108.768C169.533 108.431 173.918 97.9762 175.812 91.2054C177.328 85.7887 180.094 71.377 181.288 64.8482M183.831 53.1482C185.474 53.3646 188.381 55.1514 186.866 60.5681C185.351 65.9848 182.516 65.6784 181.288 64.8482M183.831 53.1482L181.288 64.8482",
    stroke: "#040222",
    strokeWidth: 1.85808,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.031 70.2934C170.448 71.8766 168.314 74.8195 164.447 73.9251C160.579 73.0306 161.622 69.7507 162.626 68.2225",
    stroke: "#040222",
    strokeWidth: 1.23464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.19 32.9867C167.566 30.2199 178.144 24.5254 185.449 23.8825C190.508 23.5456 190.119 26.503 188.744 29.3307C187.368 32.1583 192.817 28.864 199.251 25.6995C205.685 22.535 218.163 19.1634 226.179 19.2158M160.744 38.0735C163.33 38.7482 169.762 39.6618 174.805 37.9188C181.109 35.7401 178.748 38.438 183.547 40.0727C187.387 41.3805 191.979 39.5112 193.795 38.4131M150.002 58.7229L151.3 48.8649M158.383 40.7713L152.311 64.0413L180.899 67.805M172.002 51.5903L173.065 58.7505L168.007 59.0874M141.492 77.6603C142.936 76.8476 145.902 74.6306 146.214 72.2646M149.431 70.6824C146.706 78.6811 142.824 96.4895 149.091 103.733C156.925 112.788 167.692 107.185 168.937 105.343",
    stroke: "#040222",
    strokeWidth: 1.23464,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.315 48.9192C160.188 47.3627 162.724 44.3535 165.878 44.7688C169.396 45.2319 170.147 48.5232 169.292 51.2356C169.624 50.6107 170.88 49.4388 173.246 49.7503C174.901 49.9682 175.281 50.6726 175.218 51.2864C176.894 47.2246 179.694 47.6418 182.378 48.9468C185.205 50.3219 185.153 58.3381 179.108 58.5452C174.272 58.7109 174.326 54.2384 174.958 51.9815C175.041 51.7364 175.128 51.5049 175.218 51.2864C175.281 50.6726 174.901 49.9682 173.246 49.7503C170.88 49.4388 169.624 50.6107 169.292 51.2356C169.189 51.5637 169.062 51.8834 168.913 52.1886C167.538 55.0162 166.293 56.8581 162.349 56.3389C158.406 55.8198 157.94 51.7468 159.315 48.9192Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.27 49.1263C154.299 48.9275 156.949 48.6077 159.315 48.9192M159.315 48.9192C160.188 47.3627 162.724 44.3535 165.878 44.7688C169.396 45.2319 170.147 48.5232 169.292 51.2356M159.315 48.9192C157.94 51.7468 158.406 55.8198 162.349 56.3389C166.293 56.8581 167.538 55.0162 168.913 52.1886C169.062 51.8834 169.189 51.5637 169.292 51.2356M169.292 51.2356C169.624 50.6107 170.88 49.4388 173.246 49.7503C175.612 50.0618 175.373 51.3676 174.958 51.9815M174.958 51.9815C174.326 54.2384 174.272 58.7109 179.108 58.5452C185.153 58.3381 185.205 50.3219 182.378 48.9468C179.55 47.5716 176.593 47.1823 174.958 51.9815ZM176.8 53.2269C177.383 52.3649 178.628 51.2276 180.029 51.5527M181.858 52.89C181.246 52.0922 180.623 51.6907 180.029 51.5527M162.142 50.2943C162.868 49.3064 164.206 48.0341 165.429 48.1837M167.201 49.9574C166.722 48.7652 166.093 48.265 165.429 48.1837M165.429 48.1837L165.1 50.6837M180.029 51.5527L179.757 53.6162",
    stroke: "#040222",
    strokeWidth: 1.23464,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.135 119.243C152.578 123.206 146.929 107.46 146.523 100.386C147.05 101.458 149.106 105.139 153.631 107.339C158.155 109.539 162.832 108.55 164.604 107.781C164.518 108.438 165.965 112.933 165.135 119.243Z",
    fill: "#040222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.603 62.1742C167.491 61.4224 167.876 60.0728 168.006 59.087L169.978 59.3466C170.133 60.7043 170.076 63.1705 168.603 62.1742Z",
    fill: "#040222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.143 187.415C262.143 187.415 288.553 187.415 294.054 187.415C299.586 187.415 317.152 187.415 322.683 187.415C328.215 187.415 335.144 188.539 340.067 193.949C344.96 199.359 345.173 204.677 345.295 206.835C345.386 208.993 344.353 210.148 343.107 210.148C341.86 210.148 340.706 208.567 340.614 207.413C340.554 206.227 338.578 200.24 334.536 197.687C330.494 195.134 328.731 194.496 325.327 194.739C325.327 194.739 321.924 189.968 310.192 190.241C310.192 190.241 320.921 189.481 325.327 194.739C327.364 197.14 322.531 198.781 322.531 198.781C322.531 198.781 321.407 194.557 309.281 194.162C309.281 194.162 319.735 194.466 322.531 198.781C325.327 203.097 320.374 203.431 320.374 203.431C320.374 203.431 320.161 198.72 303.719 199.45C303.719 199.45 317.973 198.204 320.374 203.431C321.954 206.835 318.55 209.358 316.392 210.756C314.234 212.154 311.043 211.971 307.305 211.971C303.597 211.971 299.616 211.789 297.124 210.482C297.124 210.482 300.528 209.114 300.528 206.227L309.676 205.498L300.528 206.227C300.528 206.227 300.406 209.297 297.124 210.482C293.872 211.667 284.906 211.394 268.769 212.397C252.631 213.369 262.143 187.415 262.143 187.415Z",
    fill: "#FAE900",
    stroke: "#040222",
    strokeWidth: 1.86301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.505 103.929C49.9795 103.929 47.5482 103.929 47.5482 103.929H25.6662C25.6662 103.929 20.2261 119.641 18.4634 131.068C16.7006 142.496 17.8859 150.732 30.0426 150.732C38.7954 150.732 41.865 141.219 43.111 134.533C51.9246 134.533 56.0275 129.883 57.0304 122.255C58.0941 114.627 60.2823 103.929 53.505 103.929ZM52.8971 110.524C52.7148 111.891 51.0129 122.954 50.4962 126.297C49.9795 129.64 43.8404 129.853 43.8404 129.853C43.9012 129.397 43.962 129.002 43.9924 128.698C44.4482 126.023 46.211 113.259 47.0619 107.15C47.0619 107.15 48.6727 107.241 50.2227 107.333C51.7726 107.424 53.0491 109.126 52.8971 110.524Z",
    fill: "#AE90E8",
    stroke: "#040222",
    strokeWidth: 1.86301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7615 78.1871C34.5399 79.1293 31.8047 83.4449 31.8047 88.7026C31.8047 93.9604 35.9076 94.2339 39.1899 94.2339C42.4418 94.2339 46.2711 91.681 48.277 88.4291C50.2524 85.1772 50.1309 78.7949 50.1309 77.4881C50.1309 76.2116 52.2583 73.3852 55.0847 72.6558C57.9111 71.9568 61.8925 68.401 61.8925 64.2981C61.8925 60.1952 58.2151 56.6394 54.2337 56.6394C50.2524 56.6394 44.8427 60.3472 44.5996 64.0246C44.1741 70.1333 46.1192 71.8352 45.5721 73.8107C45.0251 75.7862 41.1653 77.1842 37.7615 78.1871Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 1.86301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9597 34.3013C69.2478 34.3013 70.0684 40.5923 70.0684 42.3551C70.0684 44.1178 67.394 49.2236 62.7744 49.2236C58.1549 49.2236 55.9971 46.306 55.9971 43.2668C55.9971 40.2276 57.3343 34.3013 63.9597 34.3013Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 1.86301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7048 120.036C70.1578 122.012 66.0245 138.697 66.0245 138.697L57.7923 144.633L50.6767 138.818L52.4994 131.312C52.4549 131.314 50.6363 131.403 49.8258 131.433C47.4552 131.494 46.5435 130.278 46.5435 128.303C46.5435 126.419 48.914 125.568 48.914 125.568C47.4552 125.659 46.9082 124.656 46.8474 123.44C46.7866 121.799 49.5826 120.857 49.5826 120.857C47.9111 121.161 46.6954 120.492 46.5435 119.216C46.3915 117.939 48.367 116.45 49.2179 115.934C50.0689 115.417 51.7404 114.809 56.208 114.262C60.6756 113.715 66.2677 114.505 69.0941 114.718C71.9205 114.931 71.2519 118.061 70.7048 120.036Z",
    fill: "#FAE900",
    stroke: "#040222",
    strokeWidth: 1.86301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.501 111.557C116.718 111.557 109.788 114.931 102.586 121.434C95.3827 127.938 53.8069 163.709 53.8069 163.709L61.6479 156.962L66.0243 138.697C66.0243 138.697 57.0588 139.639 55.1441 139.639C53.2294 139.639 50.6765 138.818 50.6765 138.818C50.6765 138.818 39.2493 180.546 37.4865 186.381C35.7238 192.217 43.1394 198.751 49.4001 195.073C55.6608 191.396 90.8847 164.378 90.8847 164.378L100.519 134.624L90.8847 164.378L65.7812 255.219C65.7812 255.219 91.9485 259.018 111.247 259.018C130.546 259.018 155.437 256.769 155.437 256.769L166.651 178.692L145.104 150.702C145.104 150.702 184.582 202.246 189.536 208.294C194.46 214.342 199.413 216.135 211.084 215.709C222.754 215.254 268.737 212.336 268.737 212.336C268.737 212.336 271.29 203.917 270.652 196.927C270.013 189.937 264.148 187.384 262.111 187.384C260.075 187.384 222.238 187.779 219.198 187.779C216.129 187.779 213.971 186.746 211.418 182.826C208.865 178.875 175.495 128.576 169.903 122.589C164.311 116.602 158.324 111.557 147.109 111.557C135.895 111.557 125.501 111.557 125.501 111.557Z",
    fill: "#5D21D2",
    stroke: "#040222",
    strokeWidth: 1.86301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.501 111.557C116.718 111.557 109.788 114.931 102.586 121.434C95.3827 127.938 53.8069 163.709 53.8069 163.709L61.6479 156.962L66.0243 138.697C66.0243 138.697 57.0588 139.639 55.1441 139.639C53.2294 139.639 50.6765 138.818 50.6765 138.818C50.6765 138.818 39.2493 180.546 37.4865 186.381C35.7238 192.217 43.1394 198.751 49.4001 195.073C55.6608 191.396 90.8847 164.378 90.8847 164.378L100.519 134.624L90.8847 164.378L65.7812 255.219C65.7812 255.219 91.9485 259.018 111.247 259.018C130.546 259.018 155.437 256.769 155.437 256.769L166.651 178.692L145.104 150.702C145.104 150.702 184.582 202.246 189.536 208.294C194.46 214.342 199.413 216.135 211.084 215.709C222.754 215.254 268.737 212.336 268.737 212.336C268.737 212.336 271.29 203.917 270.652 196.927C270.013 189.937 264.148 187.384 262.111 187.384C260.075 187.384 222.238 187.779 219.198 187.779C216.129 187.779 213.971 186.746 211.418 182.826C208.865 178.875 175.495 128.576 169.903 122.589C164.311 116.602 158.324 111.557 147.109 111.557C135.895 111.557 125.501 111.557 125.501 111.557Z",
    stroke: "#040222",
    strokeWidth: 1.86301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.763 199.116C163.763 199.116 144.525 157.722 143.765 155.108C143.006 152.495 143.461 148.483 145.163 150.702C146.865 152.92 166.711 178.692 166.711 178.692L163.763 199.116Z",
    fill: "#040222",
    stroke: "#040222",
    strokeWidth: 1.86301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7863 262.726C64.9921 262.726 77.4223 260.781 79.9144 248.259C82.4065 235.738 78.5164 226.955 65.1441 226.134C51.7717 225.313 28.4005 226.134 18.6448 226.134C8.88905 226.134 0.257812 233.124 0.257812 243.974C0.257812 254.824 5.12048 262.726 17.7938 262.726C30.4671 262.726 48.5806 262.726 56.7863 262.726Z",
    fill: "#040222",
    stroke: "#040222",
    strokeWidth: 1.86301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0343 257.954C28.0343 257.954 17.2148 321.868 16.2423 327.521C15.2698 333.174 10.5894 353.323 31.9852 353.323C42.3183 353.323 52.1349 353.323 52.1349 353.323C52.1349 353.323 52.1349 349.676 52.1349 348.4C52.1349 347.123 50.0074 345.026 50.0074 345.026C50.0074 345.026 38.7017 344.965 34.6293 345.026C28.1558 345.148 22.3206 342.443 25.1774 328.341C27.1833 318.312 38.1547 257.985 38.1547 257.985H28.0343V257.954Z",
    fill: "white",
    stroke: "#040222",
    strokeWidth: 1.86301,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11158_31070"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 535,
    height: 493.353,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTomtalker);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tomtalker.f14eb59ab9908bab405be016a8b87913.svg";